import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { useParams } from 'react-router-dom';
import { BaseLocationsSelectSearch } from 'src/components/SelectSearch/BaseLocationsSelectSearch';
import { ILocation } from 'src/types/Location';
import { MAX_LOCATIONS_ALLOWED } from 'src/components/enterprise/features/Reporting/CreateReportsPage/components/Form/LocationsSelectControl/LocationsSelectControl.utils';
import { maxAllowedItemsValidation } from 'src/components/SelectSearch/utils/maxAllowedItemsValidation';

interface LocationsSelectControlProps {
  name: string;
}

export const LocationsSelectControl: React.FC<LocationsSelectControlProps> = ({
  name,
}) => {
  const { setValue } = useFormContext();
  const { corpid: corpId } = useParams<{ corpid: string }>();

  return (
    <BaseLocationsSelectSearch
      name={name}
      corpId={corpId}
      label={`Add up to ${MAX_LOCATIONS_ALLOWED} locations`}
      rules={{
        validate: {
          maxLocations: maxAllowedItemsValidation<ILocation>(
            MAX_LOCATIONS_ALLOWED,
            `You have exceeded the max number of ${MAX_LOCATIONS_ALLOWED} locations`
          ),
        },
      }}
      onValueChange={(locations: ILocation[] = []): void => {
        setValue(name, locations, { shouldValidate: true });
      }}
    />
  );
};
